module.exports = __webpack_public_path__ + "img/mobile-front-arrow.5f0b9bd8.svg";